module.exports = __webpack_public_path__ + "assets/img/faceicon.f6f7c031.jpg";